let Button = (props) => {
  return (
    <button
      onClick={props.onPress}
      className={`button-app ${props.buttonStyle}`}
      disabled={props.loadingPosting ? true : false}
    >
      {props.children}{" "}
    </button>
  );
};

export default Button;
